import { SharedEntityState } from './models';

export function getInitialSharedEntityState<
  Entity
>(): SharedEntityState<Entity> {
  return {
    // set initial required properties
    loadedAll: false,
    entities: {},
    ids: [],
  };
}

export function createInitialStateFactory<Entity>() {
  function getInitialState(): SharedEntityState<Entity>;
  function getInitialState<S extends object>(
    additionalState: S
  ): SharedEntityState<Entity> & S;
  function getInitialState(additionalState: any = {}): any {
    return Object.assign(getInitialSharedEntityState(), additionalState);
  }

  return { getInitialState };
}
